import { render, staticRenderFns } from "./issueTrue.vue?vue&type=template&id=f584ec1a&scoped=true"
import script from "./issueTrue.vue?vue&type=script&lang=js"
export * from "./issueTrue.vue?vue&type=script&lang=js"
import style0 from "./issueTrue.vue?vue&type=style&index=0&id=f584ec1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f584ec1a",
  null
  
)

export default component.exports